import {
  getFirestore,
  collection,
  getDocs,
  query,
  where as whereFn,
  orderBy as orderByFn,
  startAfter,
  limit,
} from "firebase/firestore";

const db = getFirestore();

export const getEventSubCollection = async ({
  collectionName,
  docId,
  subCollectionName,
  where = null,
  orderBy = null,
  lastDocument = null,
  pageSize = null,
}) => {
  try {
    const subCollectionRef = collection(db, collectionName, docId, subCollectionName);
    const constraints = [];

    if (where && where.field && where.op && typeof where.value !== "undefined") {
      constraints.push(whereFn(where.field, where.op, where.value));
    }

    if (orderBy && orderBy.field) {
      constraints.push(orderByFn(orderBy.field, orderBy.direction || "asc"));
    }

    if (lastDocument) {
      constraints.push(startAfter(lastDocument));
    }

    if (pageSize) {
      constraints.push(limit(pageSize));
    }

    const q = query(subCollectionRef, ...constraints);
    const querySnapshot = await getDocs(q);
    const data = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

    const lastDoc =
      querySnapshot.docs.length > 0 ? querySnapshot.docs[querySnapshot.docs.length - 1] : null;

    return { data, lastDoc };
  } catch (error) {
    console.error("Erreur lors de la récupération des données de la sous-collection :", error);
    if (error.code && error.code === 400) throw error;
    throw { code: 500, message: "Erreur interne du serveur." };
  }
};
